<div
  [ngClass]="additionalClasses()"
  class="bg-[rgba(255,255,255,0.6)] shadow-lg rounded-2xl min-h-fit border border-gray-100"
>
  <ng-content />
</div>
